import { AxiosResponse } from "axios";
import { apiNode } from "./api";
import { DefaultGetParamsProps } from "./types/interfaces";
import {
	CreateRoleDataProps,
	GetRoleUsersDataResponse
} from "./types/role.interfaces";

const URL = "2/roles/v2/roles";

export const RoleService = {
	async create({ data }: { data: CreateRoleDataProps }) {
		return apiNode.post(`${URL}/create`, data);
	},
	async rename({
		name,
		id
	}: {
		name: string;
		id: string;
	}) {
		return apiNode.patch(`${URL}/${id}/rename`, { name });
	},
	async delete({ id }: DefaultGetParamsProps) {
		return apiNode.delete(`${URL}/${id}/delete`);
	},
	async updateUsers({
		usersIds,
		id
	}: {
		usersIds: { id: string }[];
		id: string;
	}) {
		return await apiNode.put(`${URL}/${id}/users`, { users: usersIds });
	},
	async addUser({
		userId,
		id
	}: {
		userId: string;
		id: string;
	}) {
		return await apiNode.patch(`${URL}/${id}/users/${userId}`, { userId });
	},
	async deleteUser({
		userId,
		id
	}: {
		userId: string;
		id: string;
	}) {
		return await apiNode.delete(`${URL}/${id}/users/${userId}`);
	},
	async getUsers({
		id
	}: DefaultGetParamsProps) {
		const response: AxiosResponse<GetRoleUsersDataResponse> =
			await apiNode.get<GetRoleUsersDataResponse>(`${URL}/${id}/users`);
		return response?.data;
	}
};
